import React from 'react';
import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { HERO_BG_GRADIENT } from './homePageVisuals';

const driftA = keyframes`
  0%, 100% { transform: translate(0%, 0%) scale(1); }
  33% { transform: translate(8%, -6%) scale(1.08); }
  66% { transform: translate(-5%, 4%) scale(0.95); }
`;

const driftB = keyframes`
  0%, 100% { transform: translate(0%, 0%) scale(1); }
  40% { transform: translate(-10%, 8%) scale(1.1); }
  70% { transform: translate(6%, -5%) scale(0.92); }
`;

const driftC = keyframes`
  0%, 100% { transform: translate(0%, 0%) rotate(0deg); }
  50% { transform: translate(5%, 6%) rotate(12deg); }
`;

export default function AuroraBackground() {
	return (
		<Box position='absolute' inset={0} overflow='hidden' pointerEvents='none' aria-hidden>
			<Box
				position='absolute'
				top='-30%'
				right='-15%'
				w='70%'
				h='70%'
				borderRadius='full'
				bg='radial-gradient(circle, rgba(34,211,238,0.35) 0%, transparent 65%)'
				filter='blur(60px)'
				animation={`${driftA} 18s ease-in-out infinite`}
			/>
			<Box
				position='absolute'
				bottom='-25%'
				left='-20%'
				w='65%'
				h='65%'
				borderRadius='full'
				bg='radial-gradient(circle, rgba(168,85,247,0.28) 0%, transparent 65%)'
				filter='blur(70px)'
				animation={`${driftB} 22s ease-in-out infinite`}
			/>
			<Box
				position='absolute'
				top='30%'
				left='25%'
				w='45%'
				h='45%'
				borderRadius='full'
				bg='radial-gradient(circle, rgba(59,130,246,0.2) 0%, transparent 70%)'
				filter='blur(50px)'
				animation={`${driftC} 14s ease-in-out infinite`}
			/>
			<Box
				position='absolute'
				inset={0}
				bg={HERO_BG_GRADIENT}
				opacity={0.55}
			/>
		</Box>
	);
}
